import React from 'react'
import PropTypes from 'prop-types'
import {
    ColorConsts,
    ElementSizeType,
    errorButtonColors,
    errorButtonLightColors,
    grayButtonLight,
    warningButtonColors
} from '@styles/theme-const'
import { _PricePropTypes } from 'src/consts'
import * as S from './PriceBlock.styled'
import Button from '@shared/Button/Button'
import PriceItem from './PriceItem'

import LikeIcon from '../../Icons/LikeIkon'
import { useBasketGoodPositionCount } from '@entities/basket/model'
import dynamic from 'next/dynamic'
import { useOpenStockForGoods } from 'src/features/shipment-selector/hooks'
import { useFavoriteApi } from 'src/features/favorite/hooks'
export const buttonDeliveryNotAvailableColors = {
    backgroundColor: ColorConsts.white,
    color: 'rgba(0, 0, 0, 0.87)',
    hoverBackgroundColor: ColorConsts.redLightBackground,
    shadowColor: ColorConsts.redLight,
    shadowHoverColor: ColorConsts.redLightBackground,
    borderColor: ColorConsts.redLight
}

const hocRender = (isLiked, likeHandler, content) => (
    <S.Container>
        <S.BlockLike>
            <S.LikedContainer>
                <S.LikedIconBlock isLiked={isLiked} onClick={likeHandler}>
                    <LikeIcon />
                </S.LikedIconBlock>
            </S.LikedContainer>
        </S.BlockLike>
        <S.BlockPrice>{content}</S.BlockPrice>
    </S.Container>
)

const ChangerGood = dynamic(() => import('src/features/add-basket/changer-good').then((x) => x.ChangerGood), {
    ssr: false
})

const PriceBlock = (props) => {
    const { toggle, isLiked } = useFavoriteApi(props.goodId)
    const basketGoodPositionCount = useBasketGoodPositionCount(props.goodId)
    const openStockForGoods = useOpenStockForGoods()
    const isStockAvl = props.isAvailableOnStock && props.stockPrice.normal
    const isDeliveryAvl =
        (props.deliveryStatus.isAvailableForDelivery || props.children.isAvailableDeliveryByErecipe) &&
        props.deliveryPrice.normal

    if (!props.isAvailable) {
        return hocRender(
            isLiked,
            toggle,
            props.options.isBasket ? (
                <S.ButtonBasketContainer>
                    <S.DeleteContainer>
                        <Button elementSizeTypeValue={ElementSizeType.regular} colors={grayButtonLight}>
                            Нет в наличии
                        </Button>
                        <Button
                            data-basket-delete
                            elementSizeTypeValue={ElementSizeType.regular}
                            colors={errorButtonColors}
                            clickHandler={props.deleteItemHandler}>
                            Удалить
                        </Button>
                        <Button
                            elementSizeTypeValue={ElementSizeType.regular}
                            colors={warningButtonColors}
                            clickHandler={props.hiddenItemHandler}>
                            Отложить
                        </Button>
                    </S.DeleteContainer>
                </S.ButtonBasketContainer>
            ) : (
                <S.Price>
                    <S.ButtonBasketContainer>
                        <S.DeleteContainer>
                            <Button elementSizeTypeValue={ElementSizeType.regular} colors={grayButtonLight}>
                                Нет в наличии
                            </Button>
                        </S.DeleteContainer>
                    </S.ButtonBasketContainer>
                </S.Price>
            )
        )
    }

    const clickHandlerDeliveryReasons = () => {
        props.openDeliveryReasons(
            props.deliveryStatus.reasons.map((reason) => ({
                id: reason.deliveryReasonID,
                text: reason.warningText
            }))
        )
    }

    const generatePrice = () => {
        const prices = []
        prices.push(
            <React.Fragment>
                <PriceItem
                    isSelectedStock={props.isSelectedStock}
                    availableStocksCount={props.availableStocksCount}
                    clickOpenAnotherStockHandler={() => openStockForGoods([props.goodId])}
                    isFrom={!isStockAvl}
                    price={isStockAvl ? props.stockPrice : props.minPrice}
                    title="Цена самовывоза"
                />
            </React.Fragment>
        )
        if (isDeliveryAvl) {
            prices.push(
                <PriceItem
                    clickOpenAnotherStockHandler={() => openStockForGoods([props.goodId])}
                    price={props.deliveryPrice}
                    title="Цена доставки"
                />
            )
        } else {
            prices.push(
                <S.Price>
                    <S.ButtonBasketContainer>
                        <Button
                            colors={errorButtonLightColors}
                            clickHandler={clickHandlerDeliveryReasons}
                            textTransform="none"
                            elementSizeTypeValue={ElementSizeType.regular}>
                            Доставка невозможна
                        </Button>
                    </S.ButtonBasketContainer>
                </S.Price>
            )
        }
        return prices.map((Component, index) => React.cloneElement(Component, { key: index }))
    }

    const generatePriceBasket = () => {
        if (!props.options.isDelivery) {
            if (!isStockAvl) {
                return (
                    <React.Fragment>
                        <PriceItem
                            price={props.minPrice}
                            isSelectedStock={props.isSelectedStock}
                            availableStocksCount={props.availableStocksCount}
                            clickOpenAnotherStockHandler={() => openStockForGoods([props.goodId])}
                            title="Цена самовывоза"
                            isFrom
                        />
                    </React.Fragment>
                )
            }
            return <PriceItem price={props.stockPrice} title="Цена самовывоза" />
        }
        if (isDeliveryAvl) {
            return <PriceItem title="Цена доставки" price={props.deliveryPrice} />
        }
        return (
            <S.Price>
                <S.ButtonBasketContainer>
                    <Button
                        colors={buttonDeliveryNotAvailableColors}
                        clickHandler={clickHandlerDeliveryReasons}
                        textTransform="none"
                        elementSizeTypeValue={ElementSizeType.regular}>
                        Доставка невозможна (причина)
                    </Button>
                </S.ButtonBasketContainer>
            </S.Price>
        )
    }

    if (!props.options.isBasket) {
        return hocRender(
            isLiked,
            toggle,
            <S.BlockPrice>
                <S.PriceDataContainer>{generatePrice()}</S.PriceDataContainer>
                <S.BasketControllerBlock>
                    <ChangerGood>{props.children}</ChangerGood>
                </S.BasketControllerBlock>
            </S.BlockPrice>
        )
    }
    const isNotAvailable = !!(
        ((!props.options.isDelivery && !isStockAvl) || (props.options.isDelivery && !isDeliveryAvl)) &&
        props.isSelectedShipment
    )

    const isChangedCount = props.bookedCount < props.count && props.isChanged

    if (props.options.isDelivery) {
        return hocRender(
            isLiked,
            toggle,
            <S.BlockPrice>
                <S.PriceDataContainer>{generatePriceBasket()}</S.PriceDataContainer>
                {isChangedCount && (
                    <S.PreorderWarningContainer>
                        <S.WarningCountSpan>В наличии {props.bookedCount} уп.</S.WarningCountSpan>
                    </S.PreorderWarningContainer>
                )}
                <S.ButtonBasketContainer>
                    {!isDeliveryAvl && props.isSelectedShipment ? (
                        <S.DeleteContainerWithoutNotAvailable>
                            <Button
                                data-basket-delete
                                elementSizeTypeValue={ElementSizeType.regular}
                                colors={errorButtonColors}
                                clickHandler={props.deleteItemHandler}>
                                Удалить
                            </Button>
                            <Button
                                elementSizeTypeValue={ElementSizeType.regular}
                                colors={warningButtonColors}
                                clickHandler={props.hiddenItemHandler}>
                                Отложить
                            </Button>
                        </S.DeleteContainerWithoutNotAvailable>
                    ) : (
                        <React.Fragment />
                    )}
                    {!isNotAvailable && props.count && <ChangerGood>{props.children}</ChangerGood>}
                </S.ButtonBasketContainer>
            </S.BlockPrice>
        )
    }
    return hocRender(
        isLiked,
        toggle,
        <S.BlockPrice>
            <S.PriceDataContainer>{generatePriceBasket()}</S.PriceDataContainer>
            {isChangedCount && (
                <S.PreorderWarningContainer>
                    <S.WarningCountSpan>В наличии {props.bookedCount} уп.</S.WarningCountSpan>
                </S.PreorderWarningContainer>
            )}
            <S.ButtonBasketContainer>
                {!isStockAvl && props.isSelectedShipment ? (
                    <S.DeleteContainerWithoutNotAvailable>
                        <Button
                            data-basket-delete
                            elementSizeTypeValue={ElementSizeType.regular}
                            colors={errorButtonColors}
                            clickHandler={props.deleteItemHandler}>
                            Удалить
                        </Button>
                        <Button
                            elementSizeTypeValue={ElementSizeType.regular}
                            colors={warningButtonColors}
                            clickHandler={props.hiddenItemHandler}>
                            Отложить
                        </Button>
                    </S.DeleteContainerWithoutNotAvailable>
                ) : (
                    <React.Fragment />
                )}
                {!isNotAvailable && basketGoodPositionCount && <ChangerGood>{props.children}</ChangerGood>}
            </S.ButtonBasketContainer>
        </S.BlockPrice>
    )
}

PriceBlock.propTypes = {
    stockPrice: _PricePropTypes,
    deliveryPrice: _PricePropTypes,
    minPrice: _PricePropTypes,
    deliveryStatus: PropTypes.shape({
        isAvailableForDelivery: PropTypes.bool.isRequired,
        reasons: PropTypes.arrayOf(
            PropTypes.shape({
                deliveryReasonID: PropTypes.number.isRequired,
                warningText: PropTypes.string
            })
        )
    }),
    count: PropTypes.number,
    bookedCount: PropTypes.number,
    isChanged: PropTypes.bool,
    isAvailable: PropTypes.bool.isRequired,
    isAvailableOnStock: PropTypes.bool.isRequired,
    openDeliveryReasons: PropTypes.func.isRequired,
    closeDeliveryReasons: PropTypes.func.isRequired,
    hiddenItemHandler: PropTypes.func,
    isSelectedStock: PropTypes.bool.isRequired,
    goodName: PropTypes.string,
    options: PropTypes.shape({
        isBasket: PropTypes.bool,
        isDelivery: PropTypes.bool
    })
}

PriceBlock.defaultProps = {
    options: {
        isBasket: false
    }
}

export default PriceBlock
